import $ from 'jquery';

const MENU_IS_ACTIVE_CLASS = 'menu-is-active';
const IS_ACTIVE_CLASS = 'is-active';
const SITE_HEADER_LARGE_MODIFIER = 'site-header--large';
const RESIZE_EVENT = 'resize.menu';
const SCROLL_EVENT = 'scroll.large';

export default class MainNavHandler {
	constructor() {
		this.resizeTimer = null;
		this.$burger = $('.hamburger');
		this.$mainNav = $('.site-header__main-nav');
		this.$body = $('body');
		this.$largeSiteHeader = $('.' + SITE_HEADER_LARGE_MODIFIER);
		this.setupEvents();
		this.styleSetup();
	}

	styleSetup(){
		this.$mainNav.find('.site-header__main-nav__links > li, .site-header__main-nav__links__lang').each(function(i, element){
			$(this).css({'animation': 'slide-in ' + (((i + 2) / 100) * 10) + 's forwards'});
		});
	}

	setupEvents() {
		this.$burger.parent().on('click', function() {
			this.$body.toggleClass(MENU_IS_ACTIVE_CLASS);
			if (this.$body.hasClass(MENU_IS_ACTIVE_CLASS)) {
				this.$burger.addClass(IS_ACTIVE_CLASS);
				$(window).off(RESIZE_EVENT);
				$(window).on(RESIZE_EVENT, this.closeMenu.bind(this));
			} else {
				this.$burger.removeClass(IS_ACTIVE_CLASS);
			}
		}.bind(this));

		if (this.$largeSiteHeader.length > 0) {
			$(window).on(SCROLL_EVENT, function() {
				this.$body.css({'overflow-y': 'hidden'});
				this.$largeSiteHeader.removeClass(SITE_HEADER_LARGE_MODIFIER);
				setTimeout(function() {
					this.$body.css({'overflow-y': 'auto'});
				}.bind(this), 300);
				$(window).off(SCROLL_EVENT);
			}.bind(this));
		}
	}

	closeMenu() {
		clearTimeout(this.resizeTimer);
		this.resizeTimer = setTimeout(function() {
			if (this.$burger.is(':hidden')) {
				this.$body.removeClass(MENU_IS_ACTIVE_CLASS);
				this.$burger.removeClass(IS_ACTIVE_CLASS);
				$(window).off(RESIZE_EVENT);
			}
		}.bind(this), 100);
	}
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/accelerator/assets/scripts/src/App/SiteHeader/MainNavHandler.js